import React, { useState, useRef } from 'react';
import useFetch from '../../hooks/useFetch';

function AdminUpload() {
  const [message, setMessage] = useState('');
  const installerInputRef = useRef(null);
  const updaterInputRef = useRef(null);
  const { fetchData, loading, error } = useFetch();

  const handleInstallerSubmit = async (event) => {
    event.preventDefault();
    if (installerInputRef.current && installerInputRef.current.files.length > 0) {
      const formData = new FormData();
      const file = installerInputRef.current.files[0];
      formData.append('file', file);

      try {
        const response = await fetchData('/api/admin/upload', {
          method: 'POST',
          body: formData,
        });

        if (response) {
          setMessage(response.message || 'Installer uploaded successfully.');
          installerInputRef.current.value = ''; // Clear the file input
        }
      } catch (err) {
        // Error handling is now done in useFetch
        setMessage('Error uploading installer.');
      }
    } else {
      setMessage('Please select an installer file to upload.');
    }
  };

  const handleUpdaterSubmit = async (event) => {
    event.preventDefault();
    if (updaterInputRef.current && updaterInputRef.current.files.length > 0) {
      const formData = new FormData();
      const file = updaterInputRef.current.files[0];
      formData.append('file', file);

      try {
        const response = await fetchData('/api/admin/upload-updater', {
          method: 'POST',
          body: formData,
        });

        if (response) {
          setMessage(response.message || 'Updater uploaded successfully.');
          updaterInputRef.current.value = ''; // Clear the file input
        }
      } catch (err) {
        setMessage('Error uploading updater.');
      }
    } else {
      setMessage('Please select an updater file to upload.');
    }
  };

  return (
    <div className="container mx-auto p-8 bg-gray-100 shadow-md rounded-lg">
      <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Upload New Version</h1>
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-4 text-center text-gray-700">Application Installer</h2>
        <form onSubmit={handleInstallerSubmit} className="flex flex-col items-center">
          <input
            type="file"
            accept=".exe"
            ref={installerInputRef}
            className="mb-4 p-2 border border-gray-300 rounded-lg w-full max-w-md bg-white"
          />
          <button
            type="submit"
            className="bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-600 transition duration-300"
            disabled={loading}
          >
            {loading ? 'Uploading...' : 'Upload Installer'}
          </button>
        </form>
      </div>

      <div className="mb-8 border-t pt-8 border-gray-300">
        <h2 className="text-xl font-semibold mb-4 text-center text-gray-700">Application Updater</h2>
        <form onSubmit={handleUpdaterSubmit} className="flex flex-col items-center">
          <input
            type="file"
            accept=".exe"
            ref={updaterInputRef}
            className="mb-4 p-2 border border-gray-300 rounded-lg w-full max-w-md bg-white"
          />
          <button
            type="submit"
            className="bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-600 transition duration-300"
            disabled={loading}
          >
            {loading ? 'Uploading...' : 'Upload Updater'}
          </button>
        </form>
      </div>

      {message && <p className="mt-4 text-center text-lg text-gray-800">{message}</p>}
      {error && <p className="mt-4 text-center text-lg text-red-600">{error.message}</p>}
    </div>
  );
}

export default AdminUpload;
